export const LOCALES = ["fr", "en"] as const;

export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "fr";

/** Nom de chaque langue dans sa propre langue, comme le veut l'usage. */
export const LOCALE_NAMES: Record<Locale, string> = {
  fr: "Français",
  en: "English",
};

export const isLocale = (value: unknown): value is Locale =>
  typeof value === "string" && (LOCALES as readonly string[]).includes(value);

/**
 * Langue préférée du visiteur, déduite de `navigator.languages` : la première
 * qui correspond à une langue disponible gagne. On compare sur la sous-balise
 * primaire (`fr-CA` → `fr`), parce que la région ne change rien ici.
 */
export const detectLocale = (
  preferences: readonly string[] = globalThis.navigator?.languages ?? [],
): Locale => {
  for (const preference of preferences) {
    const primary = preference.toLowerCase().split("-")[0];

    if (isLocale(primary)) {
      return primary;
    }
  }

  return DEFAULT_LOCALE;
};
